import React from 'react';

export default function Title({ value }: { value: string|undefined }) {
    let title = 'Admin.Juje'

    if (typeof value !== 'undefined') {
        title += ` - ${value}`;
    }

    return (
        <title>{title}</title>
    );
}
